//默认时间
const normalTime = time => {
    if (time) {
        var oDate = new Date();
        oDate.setTime(time);

        var y = oDate.getFullYear();
        var m = oDate.getMonth() + 1;
        var d = oDate.getDate();

        var h = oDate.getHours();
        var m = oDate.getMinutes();
        var s = oDate.getSeconds();

        return y + "-" + m + "-" + d + " " + h + ":" + m + ":" + s;
    }
};
//补零
const fillZero = num => {
    return num < 10 ? "0" + num : num;
};
//带参数
//货币形式
const currency = (value, unit, decimal) => {
    let reg = /^[0-9]+.?[0-9]*$/;
    if (!reg.test(value)) return "";
    value = decimal == undefined ? value : value.toFixed(decimal);
    return `${unit}${value}`;
};
//首字母大写
const capitalize = value => {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
};
//时间戳转换为指定格式时间
const timeFormat = (value, format) => {
    let date = new Date(value);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let min = date.getMinutes();
    let s = date.getSeconds();
    let result = "";
    if (format == undefined) {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
            h < 10 ? "0" + h : h
            }:${min < 10 ? "0" + min : min}`;
    }
    if (format == "yyyy-mm-dd") {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
    }
    if (format == "yyyy-mm") {
        result = `${y}-${m < 10 ? "0" + m : m}`;
    }
    if (format == "mm-dd") {
        result = ` ${mm < 10 ? "0" + mm : mm}:${ddmin < 10 ? "0" + dd : dd}`;
    }
    if (format == "hh:mm") {
        result = ` ${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}`;
    }
    return result;
};

//过滤非法字符
const validate = (val) => {
    val = val.toString();
    reg = /[`~!@#$%^&*()_+<>?:"{},\/;']/im;

    if (reg.test(val)) {
        $.alert("请勿输入非法字符", "温馨提示");
        //返回时删除非法字符
        return val.substr(0, val.length - 1);
    } else {
        //原内容返回
        return val;
    }
};

const timeTop = (val) => {
    if (!val) {
        return ''
    }
    return val.split(' ')[0]
}
const timeBottom = (val) => {
    if (!val) {
        return ''
    }
    return val.split(' ')[1]
}
//支付方式
const payType = (val) => {
    if (val == 1) {
        return '微信'
    }
}

//公司
const company = (val) => {
    if (val == 1) {
        return '尼普顿'
    } else if (val == 2) {
        return '三鑫'
    }
}
//true false
const TrueOrFalse = (val) => {
    if (val) {
        return '是'
    } else {
        return '否'
    }
}
//订单状态
const orderStatus = (value) => {
    if (value == 1) {
        return "未支付";
    } else if (value == 2) {
        return "待审核";
    } else if (value == 3) {
        return "租赁中";
    } else if (value == 4) {
        return "已过期";
    } else if (value == 5) {
        return "已退租";
    } else if (value == 6) {
        return "拒审";
    } else if (value == 7) {
        return "已取消";
    } else if (value == 8) {
        return "订单超时";
    }
}
const auditBackStatus = (value) => {
    if (value == 0) {
        return "待审核";
    } else if (value == 1) {
        return "驻点已审核";
    } else if (value == 2) {
        return "数据中心已审核";
    } else if (value == 3) {
        return "拒审核";
    }
}
const auditStatus = (value) => {
    if (value == 0) {
        return "待审核";
    } else if (value == 1) {
        return "已审核";
    } else if (value == 2) {
        return "拒审核";
    }
}
//遥控器状态
const remoteControlStatus = (value) => {
    if (value == 1) {
        return "损坏";
    } else if (value == 2) {
        return "完整";
    } else if (value == 2) {
        return "未领取";
    }
}


export default {
    normalTime,
    fillZero,
    currency,
    capitalize,
    timeFormat,
    validate,
    timeTop,
    timeBottom,
    payType,
    company,
    TrueOrFalse,
    orderStatus,
    auditStatus,
    auditBackStatus,
    remoteControlStatus,
};